import { Preferences } from "@capacitor/preferences";
import { v4 as uuidv4 } from "uuid";

const STICKY_SESSION_ID_KEY = "stickySessionCleintId";

export const getOrCreateStickySessionId = async (): Promise<string> => {
  const { value } = await Preferences.get({ key: STICKY_SESSION_ID_KEY });
  if (value) {
    console.log("Sticky session ID found:", value);
    return value;
  } else {
    const newId = uuidv4();
    await Preferences.set({ key: STICKY_SESSION_ID_KEY, value: newId });
    console.log("New sticky session ID created:", newId);
    return newId;
  }
};

export const clearStickySessionId = async (): Promise<void> => {
  await Preferences.remove({ key: STICKY_SESSION_ID_KEY });
  console.log("Sticky session ID cleared.");
};
